import anime from "animejs";
import cx from "classnames";
import * as React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { StoreProvider } from "../utils/storeContext";
import SearchBar from "../components/shearchBar/searchBar";
import SearchResult from "../components/searchResult/searchResult";

import styles from "../styles/_pages/index.module.scss";

interface Props {
  signature: any;
}

const IndexPage: React.FC<{ location: Location }> = ({ location }: { location: Location }) => {
  const data: Props = useStaticQuery(graphql`
    query {
      signature: file(relativePath: { eq: "elinoi-signature.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const $bodyWrapper = React.useRef(null);
  const title = React.useRef(null);
  const text = React.useRef(null);
  const logo = React.useRef(null);
  const backgroundText = React.useRef(null);

  React.useEffect(() => {
    const timeline = anime.timeline({
      delay: 200,
      duration: 1200,
      easing: "cubicBezier(0.74, 0.04, 0.34, 0.95)",
    });
    timeline
      .add(
        {
          opacity: 1,
          duration: 400,
          targets: $bodyWrapper.current,
        },
        0,
      )
      .add(
        {
          translateY: [60, 0],
          opacity: [0, 1],
          duration: 1000,
          targets: title.current,
        },
        0,
      )
      .add(
        {
          translateY: [100, 0],
          opacity: [0, 0.5],
          duration: 1000,
          targets: text.current,
        },
        200,
      )
      .add(
        {
          rotate: [-50, 0],
          opacity: [0, 1],
          duration: 1000,
          easing: "easeInOutQuint",
          targets: logo.current,
        },
        "-=1000",
      )
      .add(
        {
          translateX: [100, 0],
          opacity: [0, 0.16],
          duration: 4000,
          easing: "easeOutExpo",
          targets: backgroundText.current,
        },
        "-=1000",
      );
  }, []);

  return (
    <Layout>
      <SEO
        title="Simulateur de salaire"
        meta={{
          "og:image": "https://elinoi-uploads.s3.eu-west-3.amazonaws.com/partage-btob-simu.png",
          "og:image:height": "1030",
          "og:image:secure_url": "https://elinoi-uploads.s3.eu-west-3.amazonaws.com/partage-btob-simu.png",
          "og:image:width": "1280",
          "og:url": location.href,
        }}
      />
      <div className={styles.bodyWrapper} ref={$bodyWrapper} style={{ opacity: 0 }}>
        <div className={styles.contentWrapper}>
          <div className={styles.background}>
            <div className={styles.signature} ref={logo}>
              <div className={styles.squareContainer}>
                <div className={styles.square}></div>
              </div>
              <div className={styles.squareContainer}>
                <div className={styles.square}></div>
              </div>
            </div>
            <div className={styles.backgroundText} ref={backgroundText}>
              Salaires
            </div>
          </div>
          <div className={styles.content}>
            <h1 ref={title}>
              Les bons ont un prix de marché. <span>Lequel ?</span>
            </h1>
            <p ref={text}>
              Le salaire est l'un des 3 critères principaux qui influent sur l'acceptation d'une offre par un talent. Et
              pas des moindres. Alors parlons peu, parlons bien, parlons argent.
            </p>
          </div>
        </div>
        <StoreProvider>
          <div className={styles.searchBarContainer}>
            <SearchBar />
          </div>
          <div className={styles.searchResultContainer}>
            <SearchResult />
          </div>
        </StoreProvider>
      </div>
    </Layout>
  );
};

export default IndexPage;
